import React, {useCallback} from 'react';
import {showConfirmMessage} from '../../../../../_shared/Messages/actions/MessageActions';
import {
    getMacroActionsFromServer,
    getMacroNameById,
    isRecursiveByActions,
    onDeleteMacro,
    startMacro,
    stopRecording
} from '../../../../../_legacy/Macro/actions/macroActions';
import {sendMonitor} from '../../../../../utils/monitoring';
import {macroFooterRef} from '../../../../../_legacy/Macro/constants';
import {MacroSubMenu} from '../../../../../_legacy/Macro/components/MacroMenu';
import texts from '../../../../../_legacy/Macro/texts';
import {formsStore} from '../../../../../_legacy/Form/stores/FormsStore';
import {macroDlgRef} from '../../../../../_legacy/Macro/components/MacroDialog';

type Props = {
    isSubmenuOpen: boolean;
    isHovering: boolean;
    handleClose: () => void;
    handleCloseSubMenu: () => void;
    useBridgeAPI?: boolean;
    handleShowHelp: (e, desc: string) => void;
};

export const OldMacroSubMenu = ({
    isSubmenuOpen,
    isHovering,
    handleClose,
    handleCloseSubMenu,
    useBridgeAPI,
    handleShowHelp
}: Props) => {
    const handleDeleteMacro = (macroID: number) => {
        showConfirmMessage({
            title: texts.menu_deleteMessage,
            onConfirm: () => onDeleteMacro(macroID),
            confirmButtonText: texts.menu_deleteYes,
            cancleButtonText: texts.menu_deleteNo,
            defaultButton: 0
        });
        // preventClose.current = true;
    };

    const handleStartRecording = () => {
        sendMonitor('RecordMacro');
        handleClose();
        macroDlgRef.current.handleShowDialog();
    };

    const handleEditMacro = async (e, macro) => {
        e.stopPropagation();

        const macroActions = await getMacroActionsFromServer(macro.macro);
        const isRecursive = isRecursiveByActions(macroActions, macro.macro);
        macroDlgRef.current.handleShowDialog({
            id: macro.macro,
            key: macro.key,
            name: macro.origtitle,
            isRecursive,
            macroActions
        });
        handleClose();
    };

    const handleStopRecording = () => {
        stopRecording();
        macroFooterRef?.current?.hideFooter();
    };

    const handleActivateMacro = useCallback(
        macroID => {
            const macroName = getMacroNameById(macroID);
            sendMonitor(`PlayMacro"${macroName}"`);
            handleClose();
            startMacro(macroID);
        },
        [handleClose]
    );

    return (
        <MacroSubMenu
            onHelp={handleShowHelp}
            isOpen={isSubmenuOpen}
            items={formsStore.currentForm?.macros || []}
            onDeleteMacro={handleDeleteMacro}
            onActivateMacro={handleActivateMacro}
            onStartRecording={handleStartRecording}
            onStopRecording={handleStopRecording}
            onEdit={handleEditMacro}
            onCloseSubMenu={handleCloseSubMenu}
            isHovering={isHovering}
            useBridgeAPI={useBridgeAPI}
        />
    );
};
